"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
function trackUserEvent(userId, name) {
  return (0, _actionUtils.actionCreator)(_types.TRACK_USER_EVENT, {
    userId: userId,
    name: name
  });
}
var _default = exports["default"] = trackUserEvent;